import { SxProps, Theme } from '@mui/material';
import { CSSProperties } from 'react';

/**
 * Hover/focus ring behavior for cards that navigate or act as buttons.
 * Mirrors fragment list cards: subtle border transition + shadow on hover.
 */
export const appCardInteractiveSx: SxProps<Theme> = {
  cursor: 'pointer',
  border: '1px solid transparent',
  transition: 'box-shadow 0.2s ease-in-out, border-color 0.2s ease-in-out',
  '&:hover': {
    boxShadow: 4,
    borderColor: 'primary.main',
  },
};

/**
 * Default vertical layout for grid-style cards (media → body → footer/actions).
 */
export const appCardRootSx: SxProps<Theme> = {
  height: '100%',
  display: 'flex',
  flexDirection: 'column',
};

/** Wrapper link style so the whole card inherits text color and has no underline. */
export const appCardLinkStyle: CSSProperties = {
  textDecoration: 'none',
  color: 'inherit',
  display: 'block',
};

/** Top media region: keeps aspect-friendly content from stretching the row awkwardly. */
export const appCardMediaSx: SxProps<Theme> = {
  flexShrink: 0,
  width: '100%',
};

/** Main body: grows to fill space between media and footer/actions. */
export const appCardContentSx: SxProps<Theme> = {
  flexGrow: 1,
};

/** Bottom action row: space-between friendly defaults; callers can override via `sx`. */
export const appCardActionsSx: SxProps<Theme> = {
  justifyContent: 'space-between',
  alignItems: 'center',
  flexWrap: 'wrap',
  gap: 1,
  px: 2,
  py: 1,
  mt: 'auto',
};
